import { render, staticRenderFns } from "./ServiceCenter.vue?vue&type=template&id=4841a700&scoped=true&"
import script from "./ServiceCenter.vue?vue&type=script&lang=js&"
export * from "./ServiceCenter.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCenter.vue?vue&type=style&index=0&id=4841a700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4841a700",
  null
  
)

export default component.exports